import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
  selector: 'tech-core-quiz-quiz-done',
  standalone: false,
  templateUrl: './quiz-done.component.html',
  styleUrl: './quiz-done.component.scss'
})
export class QuizDoneComponent implements OnInit {

  userName: string = "";
  userScore: string = "";

  constructor(
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.userName = params['userName'];
      this.userScore = params['userScore'];

      console.log("Received Username:", this.userName);
      console.log("Received User Totalscore:", this.userScore);
    });
  }

  navigateToScore() {
    this.router.navigate(['/score'], {queryParams: {userName: this.userName, userScore:this.userScore}});
  }

}
